import {
   MedicalDataAccessAuthorization,
   MedicalDataAccessAuthorizationWithdrawCommand,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';
import { useRefetchMedicalDataAccessAuthorization } from '../MedicalDataAccessAuthorizationPanel.hooks';

export const useMedicalDataAccessAuthorizationWithdrawCommand = (
   authorizationId: MedicalDataAccessAuthorization['id']
): UseCqrsCommandResult<MedicalDataAccessAuthorization, void> => {
   const invalidateMedicalDataAccessAuthorization = useRefetchMedicalDataAccessAuthorization();

   return useCqrsCommand(
      () => {
         const command = new MedicalDataAccessAuthorizationWithdrawCommand();
         command.medicalDataAccessAuthorizationId = authorizationId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               patientConsentsAndAuthorizationsTranslationKeys.authorizations.authorizationWithdrawn
            );
            invalidateMedicalDataAccessAuthorization();
         },
      }
   );
};
